export const icons = {
    all: require('../../images/projects/all.png'),
  };